// @ts-ignore
export const LOGIN_API_URL = import.meta.env.VITE_LOGIN_API_URL;
// @ts-ignore
export const COMMON_API_URL = import.meta.env.VITE_COMMON_API_URL;
